export const convertMinutesToTime = (timeInMinutes: number) => {
  const timeObj = { days: 0, hours: 0, min: 0 };
  const hoursAndMinutes = timeInMinutes % (24 * 60);
  timeObj.days = Math.floor(timeInMinutes / (24 * 60));
  if (hoursAndMinutes > 0) {
    timeObj.hours = Math.floor(hoursAndMinutes / 60);
    timeObj.min = hoursAndMinutes % 60;
  }
  return timeObj;
};

export const convertMinutesToISO8601 = (timeInMinutes?: number) => {
  const timeObj = convertMinutesToTime(timeInMinutes ?? 0);
  let days = '';
  if (timeObj.days) {
    days = `P${timeObj.days}D`;
  }
  return `P${days}T${timeObj.hours}H${timeObj.min}M00S`;
};
